// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.expand-enter-active[data-v-0adfc519],\n.expand-leave-active[data-v-0adfc519] {\n  transition: height 300ms ease-in-out;\n  overflow: hidden;\n}\n.expand-enter[data-v-0adfc519],\n.expand-leave-to[data-v-0adfc519] {\n  height: 0;\n}\n.transition--listing-form[data-v-0adfc519] {\n  will-change: height;\n  /* transform: translateZ(0);\n    backface-visibility: visible;\n    perspective: 1000px; */\n}\n", ""]);
// Exports
module.exports = exports;
